import React, { PropTypes } from "react";
import { Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";

export default function CopyProjectModal(props) {

    function hasDateError() {
      if (props.projectData.startDate && props.projectData.endDate) {
        return !props.projectData.startDate.isBefore(props.projectData.endDate);
      }
    }

    function isCopyDisabled() {
      return !props.projectData.startDate || props.nameError || hasDateError();
    }

    return (
      <div>
        <Modal show={props.show}>
          <div className="popover1 popover2 modal-dialog new-log-entry">
            <div className="modal-content">
                <div className="head modal-header">
                  <button style={{marginTop : "-20px", marginRight : "-5px"}} onClick={props.handleClose} type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                  </button>
                  <h2 className="modal-title">Copy project</h2>
                </div>
                <div className="content modal-body">
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <div className={props.nameError ? "form-group has-error" : "form-group"}>
                            <label htmlFor="project_name" className="col-md-3 col-sm-5 control-label">Project name:</label>
                            <div className="col-lg-6 col-md-7 col-sm-7">
                              <input value={props.projectData.name}
                                     onChange={(e) => props.handleProjectDataChange("name", e.target.value)}
                                     type="text"
                                     className="form-control"
                                     placeholder="Project name"/>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div className={hasDateError() ? "form-group has-error" : "form-group"}>
                            <label htmlFor="start_date" className="col-md-3 col-sm-5 control-label">Start Date:</label>
                            <div className="col-lg-6 col-md-7 col-sm-7">
                              <DatePicker
                                dateFormat="DD.MM.YYYY."
                                onChange={(value) => props.handleProjectDataChange("startDate", value)}
                                placeholderText="Start date"
                                selected={props.projectData.startDate}
                                showYearDropdown
                              />
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div className={hasDateError() ? "form-group has-error" : "form-group"}>
                            <label htmlFor="end_date" className="col-md-3 col-sm-5 control-label">End Date:</label>
                            <div className="col-lg-6 col-md-7 col-sm-7">
                              <DatePicker
                                dateFormat="DD.MM.YYYY."
                                onChange={(value) => props.handleProjectDataChange("endDate", value)}
                                placeholderText="End date"
                                selected={props.projectData.endDate}
                                showYearDropdown
                              />
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="modal-footer">
                  <button title="Cancel" type="button" className="btn btn-default left" disabled={isCopyDisabled()} onClick={props.handleSubmit}>Copy</button>
                  <button title="Cancel" type="button" className="btn btn-default" onClick={props.handleClose}>Cancel</button>
                </div>
            </div>
          </div>
        </Modal>
      </div>
    );
}

CopyProjectModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleProjectDataChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  nameError: PropTypes.boolean,
  projectData: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/app/components/CopyProjectModal.js
 **/